import { render, staticRenderFns } from "./ProposalNotes.vue?vue&type=template&id=ffee1dd4&"
import script from "./ProposalNotes.vue?vue&type=script&lang=js&"
export * from "./ProposalNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports